import Geocode from 'react-geocode';

import logger from './logger';

// validation latitude longitude
const long = /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/;
const lat = /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/;
const latitude = (coordinate) => lat.test(coordinate);
const longitude = (coordinate) => long.test(coordinate);
const latLong = (lat, long) => latitude(lat) && longitude(long);

const validationLatitudeLongitude = {
  latitude,
  longitude,
  latLong,
};

export function parseLatLngFromString(ll) {
  if (!ll) return { lat: null, lng: null };

  const latlng = ll.split(/, ?/);
  const lat = parseFloat(latlng[0]);
  const lng = parseFloat(latlng[1]);

  return { lat, lng };
}

export function getCoordsByAddress(value) {
  return Geocode.fromAddress(value)
    .then(
      (res) => {
        const { lat, lng } = res?.results[0]?.geometry?.location;

        return { lat: formatCoord(lat), lng: formatCoord(lng) };
      },
      (error) => {
        logger.error('map error', error);

        return { lat: null, lng: null };
      },
    )
    .catch((error) => {
      logger.error('catch map error', error);
    });
}

export function getAddressByCoords(value) {
  return Geocode.fromLatLng(value?.lat, value?.lng)
    .then(
      (res) => res?.results[0]?.formatted_address,
      (error) => {
        logger.error('map error', error);

        return '';
      },
    )
    .catch((error) => {
      logger.error('catch map error', error);

      return '';
    });
}

export function formatCoord(value) {
  return parseFloat(value).toFixed(6);
}

export function isValidCoords(value) {
  const latlng = value?.split(/, ?/) || ['', ''];
  return validationLatitudeLongitude.latLong(...latlng);
}

// export function isValidCoords(value) {
//   return typeof value === 'string' && /^-?\d+(\.\d*?[^0])?, ?-?\d+(\.\d*?[^0])?$/gm.test(value);
// }
